import { createAsyncThunk } from '@reduxjs/toolkit';

import * as api from 'api/methods';

import * as types from './types';

export const getSchools = createAsyncThunk<any, void>(
  types.GET_SCHOOLS,
  async () => {
    const schools = await api.getSchools();

    return schools;
  },
);

export const createSchool = createAsyncThunk<any, any>(
  types.CREATE_SCHOOL,
  async (data: any) => {
    const school = await api.createSchool(data);

    return school;
  },
);
